import helper from '../js/helper';

export default function meiliStats(renderOptions, { html }, { locale }) {
  const isEnglish = locale === 'en';

  const { nbHits, nbSortedHits, hitsPerPage, page, processingTimeMS, query } = renderOptions;

  const start = page * hitsPerPage + 1;
  const end = Math.min(start + hitsPerPage - 1, nbHits);

  const count = nbHits > 999 ? '999+' : nbHits;

  if (query === '') {
    return html`<div>.</div>`;
  }

  if (isEnglish) {
    return html`
      <div class="mt-4 text-muted">
        <i>Search result of "${query}".</i>
      </div>
    `;
  }

  return html`
    <div class="mt-4 text-muted">
      <i>Hasil pencarian "${query}".</i>
    </div>
  `;
}